<div class="input-group input-group-sm">
  <input [id]="input.MainElementList[0].ID" type="text"
         class="form-control q-bo-input q-bo-wrap ng-untouched ng-pristine ng-valid"
         [disabled]="input.MainElementList[0].Disabled"
         [(ngModel)]="input.MainElementList[0].Value"
         [ngClass]="setClass(input)"
         (change)="invalidSiret = $event.target.value.length !== 14">

  <div class="input-group-append">
    <button *ngIf="input.MainElementList[1].Type === 'BUTTON'"
            class="btn btn-outline-secondary q-bo-inputbtn q-bo-wrap"
            (click)="navigToSocieteCom(input.MainElementList[1], input.MainElementList[0].Value)"
            [id]="input.MainElementList[1].ID"
            [title]="input.MainElementList[1].ToolTip">
      <i class="{{input.MainElementList[1].Src}}"></i>
    </button>
  </div>

  <div class="input-group-append">
    <button *ngIf="input.MainElementList[2].Type === 'BUTTON'"
            class="btn btn-outline-secondary q-bo-inputbtn q-bo-wrap"
            (click)="OpenInseeModal(input.MainElementList[0].Value, ModalBoInsee)"
            [id]="input.MainElementList[2].ID"
            [title]="input.MainElementList[2].ToolTip">
      <i class="{{input.MainElementList[2].Src}}"></i>
    </button>
  </div>
</div>
<p *ngIf="invalidSiret" class="q-c-danger small">renseignez correctement le numéro de siret avant d'effectuer cette action.</p>

<ng-template #ModalBoInsee let-modalBoInsee>
  <div class="modal-header w-100">
    <h5 class="modal-title big-title" id="exampleModalLongTitle">Fiche INSEE</h5>

    <button type="button" class="close" aria-label="Close" (click)="modalBoInsee.close('CANCEL')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body overflow-auto">
    <div id="holdycnt" class="row">
      <div *ngFor="let bloc of blocsInsee; let i = index" class="col-md-6 col-lg-4" style="padding: 0.5rem;">
        <div id="grpInsee{{i}}" class="col-12" style="border: 2px solid var(--c-dark-grey);border-radius: 0.5rem; padding: 0.75rem;">
          <div class="col-12 font-weight-bold text-uppercase" style="padding: 0.5rem;">{{bloc.Origin}}</div>
          <ng-container *ngFor="let element of bloc.List">
            <div class="q-text-s q-bold">{{element.Insee}}</div>
            <input class="q-input-no-border form-control input-sm q-light-main-focus q-expert-m-2px q-bo-wrap"
                   [ngClass]="{'q-input-required q-main-focus': element.Queoval}"
                   [value]="element.Value"
                   disabled />
          </ng-container>
        </div>
      </div>

      <div class="col-12"><button id="ImportBtn" class="q-btn q-primary" (click)="ImportInseeParams(modalBoInsee)">Importer</button></div>
    </div>
  </div>
</ng-template>

<!--#endregion Fin Modal envoie mail Personnalisés-->
